import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { GenericRESTPagedClientManager } from "../../../../js/lib/manager/GenericRESTPagedClientManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export const SAVE_SEARCH_RESPONSE_EVENT = LS2PAC_CONSTANTS.Events.onSaveSearchResponse;
export const SAVE_SERCH_EVENT = LS2PAC_CONSTANTS.Events.onSaveSearch;
/**
 * THIS IS TO GET A LIST OF DYNAMIC LIST. ***NOT*** the list of items for a given Dynamic List
 */
export class DynamicListsClientManager extends GenericRESTPagedClientManager {
  constructor(options) {
    super(
      $.extend(
        {
          resultsPanelId: "dynamicLists",
          restUrl: LS2PAC_CONSTANTS.restUrls.getDynamicLists,
          pageSize: 20,
        },
        options
      )
    );

    this.countRestUrl = LS2PAC_CONSTANTS.restUrls.getDynamicListCount;
    this.restOptions.cancellable = true;
    this.restOptions.cache = false;
    this.sortField = this.defaultSort = "Name";
    this.addListeners();
  }
  fireSearch(event) {
    this.search(
      this.currentPage * this.pageSize,
      this.pageSize,
      this.sortField
    );
  }
  resetPageCache() {
    this.pages = [];
    this.hasResults = false;
    this.currentPage = 0;
  }
  setTotalHits(totalHits) {
    this.resetPageCache();
    this.totalHits = totalHits;
  }
  onSaveSearchHandler(_this) {
    return function (event) {
      var searchToSave = {
          scope: event.isConfigSearch ? "Public" : "Private",
          name: event.name,
          expression: event.currentSearch.searchTerm,
          sortType: event.currentSearch.sortCriteria,
          facetFilters: event.currentSearch.facetFilters,
          branchFilters: event.currentSearch.branchFilters,
          readingLevelFilters: event.currentSearch.readingLevelFilters,
        },
        restUrl = event.isConfigSearch
          ? LS2PAC_CONSTANTS.restUrls.savePublicDynamicList
          : LS2PAC_CONSTANTS.restUrls.savePrivateDynamicList,
        success = false,
        response = null;

      TLCRest.jsonCall(restUrl, {
        postData: searchToSave,
        callback: function (data) {
          success = true;
          response = data;
          // Trigger refresh of AccountSummary for counts
          AccountHolder.fetchAccountSummaryAndPatron(true);
        },
        finallyHandler: function () {
          TLCEventManager.fireEvent(
            SAVE_SEARCH_RESPONSE_EVENT,
            { success: success, data: response }
          );
        },
        timeout: 20000,
        cancellable: true,
      });
    };
  }
  onGetListCount(callback) {
    var success = false;
    var response = null;
    TLCRest.jsonCall(this.countRestUrl, {
      cache: false,
      callback: function (data) {
        success = true;
        response = data.count;
      },
      finallyHandler: function () {
        callback(response, success);
      },
      timeout: 20000,
    });
  }
  addListeners() {
    var _this = this;

    TLCEventManager.addListener(this.searchEvent, function (event) {
      _this.resetPageCache();
      _this.fireSearch(event);
      _this.addHistory(event);
    });

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.sortField = _this.defaultSort;
      }
    );

    TLCEventManager.addListener(
      SAVE_SERCH_EVENT,
      _this.onSaveSearchHandler(this)
    );
  }
}
